import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import orbe from "../assets/orbe.png";
import { gerarCashbackId } from "../utils/ids";

export function Cupom() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cupom, setCupom] = useState(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    const fetchCupom = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/ofertas`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) throw new Error("Erro ao buscar ofertas");

        const data = await res.json();

        const encontrada = data.find(
          (oferta) =>
            oferta.codigoPromocional &&
            oferta.codigoPromocional.toLowerCase() === id.toLowerCase()
        );

        if (!encontrada) throw new Error("Cupom não encontrado");

        setCupom(encontrada);
      } catch (err) {
        console.error("Erro ao buscar cupom:", err);
        setErro("Cupom não encontrado");
      }
    };

    fetchCupom();
  }, [id]);

  const handleClickOferta = () => {
    const trackingId = localStorage.getItem("trackingId");
    if (!trackingId) {
      alert("Erro: trackingId não encontrado.");
      return;
    }

    const cashbackId = gerarCashbackId();
    localStorage.setItem("cashbackId", cashbackId);

    const aff_sub7 = localStorage.getItem("sourceAfiliado") || "";

    // Substituir os marcadores no link
    const urlFinal = cupom.link
      .replace("${trackingId}", trackingId)
      .replace("${cashbackId}", cashbackId)
      .replace("${aff_sub7}", aff_sub7);

    window.open(urlFinal, "_blank");
};


  if (erro) {
    return <div className="text-center mt-20 text-xl text-red-600">{erro}</div>;
  }

  if (!cupom) {
    return <div className="text-center mt-20 text-gray-500">Carregando cupom...</div>;
  }

  return (
    <div className="bg-gray-100 min-h-screen py-10 px-4 flex flex-col items-center">
      
      {/* Botão Voltar */}
      <div className="w-full max-w-6xl mb-6">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-full font-semibold transition group"
        >
          <span className="transform group-hover:-translate-x-1 transition">
            ←
          </span>
          Voltar
        </button>
      </div>

      {/* Container Principal */}
      <div className="bg-white rounded-lg shadow-lg max-w-6xl w-full p-6 flex flex-col md:flex-row items-center justify-between gap-8">
        
        {/* Lado esquerdo: logo, nome, cashback */}
        <div className="flex flex-col items-center justify-center w-full md:w-1/3">
          <div className="bg-gray-100 py-8 px-6 rounded-lg shadow-inner mb-4 w-56 flex flex-col items-start justify-center">
            <img
              src={cupom.imagemUrl}
              alt={cupom.nome}
              className="object-contain max-h-32 max-w-full mb-3 self-center"
            />
            <p className="text-gray-800 text-base text-left w-full">{cupom.nome}</p>
            <p className="text-gray-800 text-[14px] font-bold text-left w-full">
              R${cupom.cashback},00 de cashback
            </p>
          </div>
        </div>

        {/* Lado direito: descrição e botão */}
        <div className="flex-1 flex flex-col justify-center h-full w-full md:w-2/3">
          <div className="mb-6 text-left">
            <h3 className="font-semibold text-gray-800 text-lg mb-2">{cupom.nome}</h3>
            
            {/* Renderizando HTML com segurança controlada */}
            <div
              className="text-sm text-gray-700 leading-relaxed text-justify"
              dangerouslySetInnerHTML={{ __html: cupom.descricao }}
            />
          </div>

          {/* Botão de Cashback */}
          <div className="relative w-fit mx-auto md:mx-0">
            <button
              onClick={handleClickOferta}
              className="bg-blue-700 text-white px-4 py-2 md:px-8 md:py-3 rounded-full font-semibold text-sm sm:text-base hover:bg-blue-800 transition-all relative pr-16 md:pr-20 z-0"
            >
              Quero Cashback
            </button>

            <img
              src={orbe}
              alt="Orbe"
              className="absolute right-[-20px] md:right-[-50px] bottom-[-22px] md:bottom-[-20px] w-24 h-24 md:w-28 md:h-28 pointer-events-none z-10"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
